<template>

  <m-contents-wrapper :content-type="contentType" :content-category="contentCategory" @contents="initSlider">
    <template slot-scope="{contents}">

      <div class="slider-container">
        <div class="left-slide">
          <div id="left-slides" v-for="content in contents" :key="content.id">
            <m-a class="left-slide-text" :href="{name:'SinglePage',params:{slug:content.slug}}">{{
                content.title
              }}
            </m-a>
          </div>
        </div>

        <div class="right-slide">
          <div :style="`background-image :url('${content.thumbnail}');`" v-for="content in contents.reverse()"
               :key="content.id"></div>
        </div>

        <div class="action-buttons">
          <button class="down-button">
            <b-icon icon="arrow-down"></b-icon>
          </button>

          <button class="up-button">
            <b-icon icon="arrow-up"></b-icon>
          </button>

        </div>
      </div>
    </template>
  </m-contents-wrapper>

</template>

<script>
export default {
  name: 'Slider900',
  props: {
    contentCategory: {
      default: () => {
        return ['header-slider']
      }
    },
    contentType: {
      default: 'post'
    }
  },
  data() {
    return {}
  },
  methods: {
    initSlider(data) {
      let countSlide = data.length
      const sliderContainer = document.querySelector('.slider-container')
      const slideRight = document.querySelector('.right-slide')
      const slideLeft = document.querySelector('.left-slide')
      const upButton = document.querySelector('.up-button')
      const downButton = document.querySelector('.down-button')
      let activeSlideIndex = 0

      slideLeft.style.top = `-${(countSlide - 1) * 100}vh`

      upButton.addEventListener('click', () => changeSlide('up'))
      downButton.addEventListener('click', () => changeSlide('down'))

      const changeSlide = (direction) => {
        const sliderHeight = sliderContainer.clientHeight
        if (direction === 'up') {
          activeSlideIndex++
          if (activeSlideIndex > countSlide - 1) {
            activeSlideIndex = 0
          }
        } else if (direction === 'down') {
          activeSlideIndex--
          if (activeSlideIndex < 0) {
            activeSlideIndex = countSlide - 1
          }
        }
        slideRight.style.transform = `translateY(-${activeSlideIndex * sliderHeight}px)`
        slideLeft.style.transform = `translateY(${activeSlideIndex * sliderHeight}px)`
      }


    }
  },
  mounted() {

  },

}
</script>

<style scoped>
.left-slide-text {
  font-size: 18px;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  color: var(--light-white) !important;
}

.slider-container {
  position: relative;
  overflow: hidden;
  height: 100vh;
}

.left-slide {
  height: 100%;
  width: 35%;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform .5s ease-in-out;
}

.left-slide > div {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
}

.left-slide h1 {
  font-size: 40px;
  margin-bottom: 10px;
  margin-top: -30px;
}

.right-slide {
  height: 100%;
  position: absolute;
  top: 0;
  left: 35%;
  width: 65%;
  transition: transform .5s ease-in-out;
}

.right-slide > div {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 100%;
  width: 100%;
}

button {
  background-color: #fff;
  border: none;
  color: #aaa;
  cursor: pointer;
  font-size: 1rem;
  padding: 15px;
}

button:hover {
  color: #222;
}

button:focus {
  outline: none;
}

.slider-container .action-buttons button {
  position: absolute;
  left: 35%;
  top: 50%;
  z-index: 100;
}

.slider-container .action-buttons .down-button {
  transform: translateX(-100%);
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.slider-container .action-buttons .up-button {
  transform: translateY(-100%);
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

#left-slides:nth-child(odd) {
  background-color: var(--primary);
}

#left-slides:nth-child(odd) .left-slide-text {
  background-color: var(--secondary);
}

#left-slides:nth-child(even) {
  background-color: var(--secondary);
}

#left-slides:nth-child(even) .left-slide-text {
  background-color: var(--primary);
}


#left-slides:nth-child(even) .left-slide-text {
  margin-top: -90px;
  color: black;
}

#left-slides:nth-child(odd) .left-slide-text {

  margin-top: -90px;
  color: white;
}


</style>
